import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
declare let $: any;

@Component({
  selector: 'app-accelators-list',
  templateUrl: './accelators-list.component.html',
  styleUrls: ['./accelators-list.component.css'],
})
export class AccelatorsListComponent implements OnInit {
  private listApi = environment.url + environment.initiativeList;
  showFullLocation: boolean[] = [];
  expandedIndex: number = -1;
  constructor(private getdata: ValueService, private makeapi: ApiService) {}
  @ViewChild('textElement') textElement: ElementRef | undefined;
  @ViewChild('showMoreButton') showMoreButton: ElementRef | undefined;

  /**
   * Angular lifecycle hook that is called after the component has been initialized.
   * Sets initial states and attaches event listeners for user interactions.
   */
  ngOnInit(): void {
    // Set the visibility source to true
    this.getdata.isVisibleSource.next(true);

    // Fetch the list of initiatives from the API
    this.initiativeListApi();

    // Attach a click event listener to the '.show-more' element
    $('.show-more').click(function () {
      // Check if the '.text' element has the 'show-more-height' class
      if ($('.text').hasClass('show-more-height')) {
        // Change the button text to '(Show Less)' if the class is present
        $(this).text('(Show Less)');
      } else {
        // Change the button text to '(Show More)' if the class is not present
        $(this).text('(Show More)');
      }

      // Toggle the 'show-more-height' class on the '.text' element
      $('.text').toggleClass('show-more-height');
    });
  }

  isMore: false;
  /**
   * Toggles the expansion of the accordion based on the index.
   * @param index The index of the accordion to toggle.
   */
  toggleExpand(index: number): void {
    /**
     * If the index matches the current expanded index, set the expanded index to -1 (collapsed).
     * Otherwise, set the expanded index to the given index.
     */
    this.expandedIndex = this.expandedIndex === index ? -1 : index;
  }
  /**
   * Determines if the full location text should be shown based on its length.
   * @param location - The location string to evaluate.
   * @returns True if the location length exceeds 20 characters, otherwise false.
   */
  shouldShowMore(location: string): boolean {
    // Check if the location length is greater than 20
    return location.length > 20;
  }

  /**
   * Toggles the visibility of the full location text at the specified index.
   * @param index - The index of the location to toggle visibility for.
   */
  toggleLocation(index: number): void {
    // Toggle the boolean value to show or hide the full location text
    this.showFullLocation[index] = !this.showFullLocation[index];
  }

  list = {};
  disList: any = [];
  noData = true;
  listData = true;
  /**
   * Fetches the list of initiatives from the API based on the pagination.
   * Updates the list object with the pagination parameters and calls the ListApi function
   * to refresh the list of initiatives.
   */
  initiativeListApi() {
    // Set the list object with the pagination parameters
    this.list = {
      /**
       * The number of items to fetch from the API
       */
      listSize: this.currentPageCount,
      /**
       * The page number to fetch from the API
       */
      pageNumber: this.paginationCount,
    };

    /**
     * Calls the ListApi function to fetch the list of initiatives from the API
     */
    this.ListApi();
  }
  /**
   * Fetches the list of initiatives from the API.
   * Subscribes to the API response and updates the component data.
   * @returns An observable containing the response from the API.
   */
  ListApi() {
    // Show the loader while fetching data
    this.getdata.amizhthLoader('show');
    // Call the API to fetch the list of initiatives
    return this.makeapi
      .method(this.listApi, this.list, 'postunauth')
      .subscribe((data) => {
        // Hide the loader after receiving data
        this.getdata.amizhthLoader('hide');
        // Check if the response contains any data
        if (data.responsemodelList != '') {
          // If there is data, update the component data
          this.noData = false;
          this.listData = false;
          this.numberOfList = data.count;
          this.totalPages = data.totalPages;
          this.countList = data.responsemodelList.length;

          // Calculate the start and end count for the current page
          if (
            this.currentPage == this.totalPages &&
            this.countList != this.numberOfList
          ) {
            this.startCount = this.startCount + this.currentPageCount;
            this.EndCount = this.numberOfList;
          } else if (this.countList == this.numberOfList) {
            this.startCount = 1;
            this.EndCount = this.numberOfList;
          }

          // Update the list of initiatives
          this.disList = data.responsemodelList;
        } else {
          // If there is no data, show the "No Data" message
          this.noData = true;
        }
      });
  }
  viewEvent(title) {
    this.getdata.initiativeId(title);
  }
  /**
   * Calculates the total number of pages based on the count of data.
   * This function is called whenever the data count changes.
   */
  Pagination_Count() {
    // Reset the loading state
    this.loading = false;
    // Get the total count of data
    let totalcount = this.numberOfList;
    // Set the total part count to the total count
    this.totalPartCount = totalcount;
    // Calculate the total number of pages by dividing the total count by the current page count
    // and rounding up to the nearest whole number.
    this.totalPages = Math.ceil(this.totalPartCount / this.currentPageCount);
  }
  p1 = 1;
  totalPartCount: any;
  paginationCount = 1;
  currentPageCount = 9;
  loading = false;
  numberOfList = 0;
  currentPage = 1;
  totalPages = 9;
  show_page = false;
  pagecount = 1;
  startCount = 1;
  EndCount = 9;
  countList = 0;
  /**
   * Handles pagination of the list.
   * @param page - The page to navigate to. Can be 'prev' or 'next'.
   */
  paginatePartList(page) {
    // Show the pagination controls
    this.show_page = true;

    // If navigating to the previous page and not on the first page
    if (page == 'prev' && this.currentPage > 1) {
      // Decrement the page count
      this.pagecount = this.pagecount - 1;

      // If the user is not on the first page
      if (this.currentPage > 1) {
        // Decrement the current page number
        let prevcount = this.currentPage;
        prevcount--;
        // Update the pagination count
        this.paginationCount = prevcount;
        // Update the current page number
        this.currentPage = prevcount;
      } else {
        // If the user is on the first page, set the pagination count to 1
        this.paginationCount = 1;
      }

      // Adjust the start and end counts for the new page
      if (this.EndCount != this.numberOfList) {
        // Decrement the start and end counts
        this.startCount = this.startCount - this.currentPageCount;
        this.EndCount = this.EndCount - this.currentPageCount;
      } else {
        // Adjust counts if on the last page
        this.startCount = this.startCount - this.currentPageCount;
        this.EndCount = this.EndCount - this.countList;
      }
    } else {
      // If navigating to the next page
      // Increment the page count
      this.currentPage = this.currentPage + 1;
      this.pagecount = this.pagecount + 1;

      // If the user is not on the last page
      if (this.currentPage > 1) {
        // Increment the current page number
        let nextcount = this.currentPage - 1;
        nextcount++;
        // Update the pagination count
        this.paginationCount = nextcount;
      }

      // Adjust the start and end counts for the new page
      if (this.currentPage != this.totalPages) {
        // Increment the start and end counts
        this.startCount = this.startCount + this.currentPageCount;
        this.EndCount = this.EndCount + this.currentPageCount;
      }
    }

    // Call the initiative list API to update the list
    this.initiativeListApi();
  }
}
